import { InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { useSearchParams } from "@/hooks/useSearchParams";
import { useCallback, useEffect } from "react";
import { useGetPaymentAccountsQuery } from "@/features/app/appApiSlice";
import { handleError } from "@/utils/handleError";
import { ISelectPaymentParams } from "@/types/base";
import { IPaymentAccountItem } from "@/features/app/types";
import * as Styled from "./SelectPaymentOperator.styles";

const PaymentOperatorSelectLabel = "Payment Operator";

export const SelectPaymentOperator = () => {
  const { data, isFetching, error } = useGetPaymentAccountsQuery();
  const { paymentAccounts: defaultOptions = [] } = data || {};
  const paymentOperators: Array<any> = Array.from(
    new Map(
      defaultOptions.map((item: IPaymentAccountItem) => [
        item.operatorId,
        {
          value: item.operatorId.toString(),
          label: item.operatorName,
        },
      ]),
    ).values(),
  );

  const { parsedSearchParams, mergeSearchParams } =
    useSearchParams<ISelectPaymentParams>();
  const { operator } = parsedSearchParams || "";

  useEffect(() => {
    if (error) {
      handleError(error);
    }
  }, [error]);

  useEffect(() => {
    if (paymentOperators?.length && !operator) {
      mergeSearchParams({
        operator: paymentOperators[0].value,
      });
    }
  }, [mergeSearchParams, operator, paymentOperators]);

  const handlePaymentOperatorChange = useCallback(
    (event: SelectChangeEvent) => {
      mergeSearchParams({
        operator: event?.target.value,
      });
    },
    [mergeSearchParams],
  );

  return (
    <Styled.FormControl disabled={isFetching}>
      <InputLabel>{PaymentOperatorSelectLabel}</InputLabel>
      <Select
        value={operator || ""}
        label={PaymentOperatorSelectLabel}
        onChange={handlePaymentOperatorChange}
      >
        {paymentOperators?.map((option: any) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </Styled.FormControl>
  );
};
